// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2wnm7","col":"styles_col__1XPPw"};